import React from 'react';

import {
  DOMAIN_URL,
  DOMAIN_URL_DE,
  DOMAIN_URL_AE,
  DOMAIN_URL_AZ,
  DOMAIN_URL_UK,
  DOMAIN_URL_KZ,
  locales,
} from 'define';
import { localBusinessSchema } from 'define/scripts';
import { usePagePathsInfo } from 'staticQueries/page-paths';

const lang = process.env.GATSBY_LANG || 'en';

export const generatePreloadFonts = () => {
  let preloadFontsSrc = [
    '/fonts/Roboto/Roboto-Bold.woff2',
    '/fonts/Roboto/Roboto-Medium.woff2',
    '/fonts/Roboto/Roboto-Regular.woff2',
    '/fonts/Roboto/Roboto-Light.woff2',
  ];

  if (lang === 'ae') {
    preloadFontsSrc = [
      '/fonts/NotoSansArabic/NotoSansArabic-Bold.woff2',
      '/fonts/NotoSansArabic/NotoSansArabic-Medium.woff2',
      '/fonts/NotoSansArabic/NotoSansArabic-Regular.woff2',
      '/fonts/NotoSansArabic/NotoSansArabic-Light.woff2',
    ];
  }

  return preloadFontsSrc.map(fontSrc => (
    <link
      key={fontSrc}
      rel="preload"
      href={fontSrc}
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
  ));
};

export const useGenerateHreflangs = pathname => {
  const pagePaths = usePagePathsInfo();
  const hreflangs = [];

  locales.forEach(({ hrefLang, domain }) => {
    const alternateLink = (
      <link key={hrefLang} rel="alternate" href={`${domain}${pathname}`} hrefLang={hrefLang} />
    );

    if (pathname === '/') {
      hreflangs.push(alternateLink);
      return;
    }

    if (pathname.includes('/blueprint/') && (hrefLang !== 'ar' || hrefLang !== 'az')) {
      hreflangs.push(alternateLink);
      return;
    }

    switch (hrefLang) {
      case 'x-default':
      case 'en-us':
        if (
          pagePaths.en.find(page => page.includes(pathname)) ||
          pathname.includes('/blueprint/')
        ) {
          hreflangs.push(alternateLink);
        }
        break;
      default:
        if (pagePaths[hrefLang].find(page => page.includes(pathname))) {
          hreflangs.push(alternateLink);
        }
        break;
    }
  });

  return hreflangs;
};

export const getUrl = pathname => {
  switch (lang) {
    case 'de':
      return `${DOMAIN_URL_DE}${pathname}`;
    case 'ae':
      return `${DOMAIN_URL_AE}${pathname}`;
    case 'az':
      return `${DOMAIN_URL_AZ}${pathname}`;
    case 'uk':
      return `${DOMAIN_URL_UK}${pathname}`;
    case 'kz':
      return `${DOMAIN_URL_KZ}${pathname}`;
    case 'en':
    default:
      return `${DOMAIN_URL}${pathname}`;
  }
};

export const getLocalBusinessSchema = () => {
  return localBusinessSchema[lang];
};
